/**
 * jQuery Payment JS
 */

const $ = window.jQuery;

// Vendors
import 'jquery.payment';
